import { createClient, SupabaseClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const publishableKey =
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY ||
  process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

let client: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient | null {
  if (!url || !publishableKey) {
    return null;
  }
  if (!client) {
    client = createClient(url, publishableKey);
  }
  return client;
}

export function isSupabaseConfigured(): boolean {
  return Boolean(url && publishableKey);
}
